// components/Templates/AuthBody/AuthBody.js
import React from 'react';
import PropTypes from 'prop-types';

const AuthBody = ({ title, error, success, children, footer }) => (
  <div className="auth-container">
    <div className="card surface-elevated surface-pad-loose">
      <div className="stack stack-loose">

        {title && (
          <div className="text-page-title">{title}</div>
        )}

        {(error || success) && (
          <div className="stack stack-tight">
            {error && (
              <div className="status status-archived" role="alert">{error}</div>
            )}
            {success && (
              <div className="status status-released" role="alert">{success}</div>
            )}
          </div>
        )}

        <div className="stack stack-normal">
          {children}
        </div>

        {footer && (
          <div className="stack stack-tight">
            {footer}
          </div>
        )}

      </div>
    </div>
  </div>
);

AuthBody.propTypes = {
  title:    PropTypes.string,
  error:    PropTypes.string,
  success:  PropTypes.string,
  children: PropTypes.node,
  footer:   PropTypes.node,
};

export default AuthBody;